import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { MediGenieLogo } from "../components/MediGenieLogo";
import { Mascot } from "../components/Mascot";
import { toast } from "sonner";

export default function Register() {
  const { registerClinic } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    clinic_name: "", clinic_slug: "",
    admin_name: "", admin_email: "", admin_password: "", admin_phone: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => {
    const v = e.target.value;
    setForm((f) => ({ ...f, [k]: k === "clinic_slug" ? v.toLowerCase().replace(/[^a-z0-9-]/g, "-") : v }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await registerClinic(form);
      toast.success("Application submitted. Our team will review it before activation.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen mg-gradient-soft flex items-center justify-center p-6">
      <div className="w-full max-w-2xl">
        <Link to="/" className="inline-block mb-6"><MediGenieLogo /></Link>
        <div className="mg-card">
          <div className="flex items-center gap-4 mb-6">
            <Mascot size={56} className="mg-float" />
            <div>
              <h1 className="text-2xl font-extrabold text-mg-navy" data-testid="register-title">Let's get your clinic ready</h1>
              <p className="text-sm text-slate-500">Submit your clinic for verification. Access is issued after approval.</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="register-form">
            <div className="md:col-span-2">
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Clinic name</label>
              <input required value={form.clinic_name} onChange={set("clinic_name")} className="mg-input" placeholder="Sunrise Family Clinic" data-testid="reg-clinic-name" />
            </div>
            <div className="md:col-span-2">
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Public booking slug</label>
              <div className="flex items-center gap-2">
                <span className="text-sm text-slate-500">medigenie.in/clinic/</span>
                <input required value={form.clinic_slug} onChange={set("clinic_slug")} className="mg-input flex-1" placeholder="your-clinic" data-testid="reg-clinic-slug" />
              </div>
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Admin name</label>
              <input required value={form.admin_name} onChange={set("admin_name")} className="mg-input" placeholder="Your full name" data-testid="reg-admin-name" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Admin phone</label>
              <input value={form.admin_phone} onChange={set("admin_phone")} className="mg-input" placeholder="+91…" data-testid="reg-admin-phone" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
              <input type="email" required value={form.admin_email} onChange={set("admin_email")} className="mg-input" placeholder="you@clinic.com" data-testid="reg-admin-email" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
              <input type="password" required minLength={6} value={form.admin_password} onChange={set("admin_password")} className="mg-input" placeholder="At least 6 characters" data-testid="reg-admin-password" />
            </div>
            <div className="md:col-span-2 mt-2">
              <button type="submit" disabled={loading} className="mg-btn-primary w-full justify-center" data-testid="register-submit">
                {loading ? "Submitting…" : "Submit application"}
              </button>
            </div>
          </form>
          <div className="mt-5 text-sm text-slate-500 text-center">
            Already have an account? <Link to="/login" className="text-mg-medical font-semibold">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
